<template>
	<button
		class="btn"
		:class="{'btn--rounded': isRounded}"
		type="button"
	>
		Add to Cart
	</button>
</template>

<script>
export default {
	name: 'AddToCartBtn',
	props: {
		isRounded: {
			type: Boolean,
			default: true,
		},
	},
};
</script>

<style lang="sass" scoped>
.btn
	background-color: #000000
	color: #ffffff

	border: 2px solid #000000

	display: flex
	justify-content: center
	align-items: center

	padding: 10px 34px

	font: inherit
	font-size: 18px
	line-height: 25px

	cursor: pointer

	transition: background-color 0.3s, color 0.3s

	&:hover
		background-color: #ffffff
		color: #000000


.btn--rounded
	border-radius: 100px

</style>
